import React, { useState, useEffect } from "react";
import { 
    Dialog, DialogTitle, DialogContent, 
    IconButton, Typography, Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEditor, EditorContent } from "@tiptap/react";
import { sharedExtensions } from "../../components/TipTapViewer/extensions";
import { UpdateService } from "../../service/update_service";
import "../../components/TipTapViewer/tiptap.css";

const updateService = new UpdateService();

function UpdatesPopUp({ usuarioId }) {

    const [pendentes, setPendentes] = useState([]);
    const [atualizacaoAtual, setAtualizacaoAtual] = useState(null);
    const [open, setOpen] = useState(false);

    const editor = useEditor({
        extensions: sharedExtensions,
        content: "",
        editable: false,
    });

    // Busca as atualizações assim que o componente carrega na tela
    useEffect(() => {
        if (usuarioId) {
            const carregarPendentes = async () => {
                try {
                    const dominioAtual = window.location.host;
                    const listaPendentes = await updateService.fetchPending(usuarioId, dominioAtual);
                    
                    if (listaPendentes && listaPendentes.length > 0) {
                        setPendentes(listaPendentes);
                        setAtualizacaoAtual(listaPendentes[0]);
                        setOpen(true);
                    }
                } catch (error) {
                    console.error("Erro ao buscar atualizações pendentes:", error);
                }
            };
            carregarPendentes();
        }
    }, [usuarioId]);

    // Atualiza o conteúdo do editor sempre que a atualização atual mudar
    useEffect(() => {
        if (editor && atualizacaoAtual) {
            try {
                const conteudoJson = JSON.parse(atualizacaoAtual.descricao);
                editor.commands.setContent(conteudoJson);
            } catch (error) {
                console.error("Erro ao interpretar o conteúdo da atualização");
            }
        }
    }, [atualizacaoAtual, editor]);

    const handleClose = async () => {
        setOpen(false);

        if (atualizacaoAtual) {
            try {
                const dominioAtual = window.location.host;
                await updateService.markAsRead(atualizacaoAtual.id, usuarioId, dominioAtual);

                // Verifica se existem mais atualizações pendentes na fila
                const restantes = pendentes.slice(1);
                
                if (restantes.length > 0) {
                    // Se houver mais de uma atualização, aguarda animação fechar e abre a próxima automaticamente
                    setTimeout(() => {
                        setPendentes(restantes);
                        setAtualizacaoAtual(restantes[0]);
                        setOpen(true);
                    }, 500); 
                }
            } catch (error) {
                console.error("Erro ao marcar atualização como lida", error);
            }
        }
    };

    if (!atualizacaoAtual) return null;

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: { borderRadius: "12px" }
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="h6" fontWeight="bold" color="#00a69a">
                    {atualizacaoAtual.titulo}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ pb: 3 }}>
                {atualizacaoAtual.imagemUrl && (
                    <Box sx={{ mb: 3, textAlign: "center" }}>
                        <img 
                            src={atualizacaoAtual.imagemUrl} 
                            alt="Atualização" 
                            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }} 
                        />
                    </Box>
                )}
                <Box className="tiptap-content" sx={{ color: "#444", fontSize: "15px" }}>
                    <EditorContent editor={editor} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default UpdatesPopUp;